const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- ui-input ---
let __fez_component_0;
{

__fez_component_0 = class {
  PROPS = {
    name: String,
    label: String,
    value: String,
    type: { type: String, default: 'text' },
    placeholder: String,
    hint: String,
    error: String,
    icon: String,
    maxlength: Number,
    required: Boolean,
    autofocus: Boolean,
    mono: Boolean,
    readonly: Boolean,
    step: Number,
  }

  onMount() {
    const input = this.state.input
    if (this.props.value) input.value = this.props.value
    if (this.props.maxlength) input.maxLength = this.props.maxlength
    if (this.props.step) input.step = this.props.step
    input.required = this.props.required
    input.readOnly = this.props.readonly
    if (this.props.autofocus) this.setTimeout(() => input.focus(), 30)
  }

  // A new `value` from the parent replaces the text; typing is never overwritten by a re-render
  // that passes the same value.
  onRefresh(props, changed) {
    if ('value' in changed) this.setValue(props.value || '')
  }

  value() {
    return this.state.input?.value ?? ''
  }

  setValue(text) {
    if (this.state.input) this.state.input.value = text
  }

  focus() {
    this.state.input?.focus()
  }

  CSS = `:fez {
display:block;label{display:grid;grid-template-columns:minmax(0,1fr);gap:6px}.label{font-size:var(--text-sm);font-weight:var(--weight-semibold);color:var(--color-text)}.required{color:var(--color-danger);margin-left:2px}.control{display:flex;align-items:center;gap:var(--space-2);height:38px;padding:0 var(--space-3);border:1px solid var(--color-border-strong);border-radius:var(--radius-md);background:var(--color-bg-raised);color:var(--color-text-subtle);transition:border-color var(--duration-fast) var(--ease),box-shadow var(--duration-fast) var(--ease);&:focus-within{border-color:var(--color-accent);box-shadow:0 0 0 3px var(--color-accent-soft)}}input{flex:1;min-width:0;height:100%;border:0;outline:0;background:transparent;color:var(--color-text);font-size:var(--text-md);&::placeholder{color:var(--color-text-subtle)}&:read-only{color:var(--color-text-muted)}}.mono input{font-family:var(--font-mono);font-size:var(--text-sm)}.invalid .control{border-color:var(--color-danger);&:focus-within{box-shadow:0 0 0 3px var(--color-danger-soft)}}.hint,.error{font-size:var(--text-xs);color:var(--color-text-muted)}.error{color:var(--color-danger);font-weight:var(--weight-medium)}
}`

  HTML = `<label class:invalid={props.error} class:mono={props.mono}>
{#if props.label}
<span class="label">{props.label}{#if props.required}<span class="required" aria-hidden="true">*</span>{/if}</span>
{/if}
<span class="control">
{#if props.icon}
<ui-icon name={props.icon} size="16"></ui-icon>
{/if}
<input fez:this="input" name={props.name} type={props.type} placeholder={props.placeholder || ''} aria-label={props.label || props.placeholder || ''} autocomplete="off" spellcheck="false" aria-invalid={props.error ? 'true' : 'false'} />
</span>
{#if props.error}
<span class="error" role="alert">{props.error}</span>
{:else if props.hint}
<span class="hint">{props.hint}</span>
{/if}
</label>`
};
}

Fez('ui-input', __fez_component_0);

export default __fez_component_0;
